import { render, staticRenderFns } from "./CustomerAddressEdit.vue?vue&type=template&id=594c5a6e&"
import script from "./CustomerAddressEdit.vue?vue&type=script&lang=js&"
export * from "./CustomerAddressEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports